import React, { Component } from 'react';
import { connect } from 'react-redux'

import './index.scss'

class SelectLanguage extends Component {
    render() {
        const { lang } = this.props

        return (
            <div className="selectLanguage-container">
                <select value={lang} className="selectLanguage-wrap" id="selectLanguage-wrap" onChange={this.props.changeLanguage}>
                    <option value={"ko"}>
                        한국어
                    </option>
                    <option value={"en"}>
                        English
                    </option>
                    <option value={"jp"}>
                        日本語
                    </option>
                </select>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(SelectLanguage)